$(() => {
  $('.js-datepicker').each(function dateInit() {
    const $this = $(this);
    const $wrapper = $this.closest('.js-datepicker-group');
    const $startDate = $wrapper.find('.js-start-date');
    const $endDate = $wrapper.find('.js-end-date');

    const setDate = (startDate = null, endDate = null) => {
      $startDate.val(startDate && startDate.getTime());
      $endDate.val(endDate && endDate.getTime());
    };

    const options = {
      range: !!$this.data('range'),
      classes: $this.data('style'),
      dateFormat: 'd M',
      multipleDatesSeparator: ' - ',
      onSelect: (formattedDate, date, inst) => {
        setDate(date[0], date[1]);
      },
    };

    $this.datepicker(options);
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/datepicker/index.js